// import React, { useEffect, useRef, useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { FaShoppingBag } from "react-icons/fa";
// import { toast } from "react-toastify";
// import axios from "axios";
// import NotificationDropdown from "./Notification";
// import './Navbar.css';

// const Navbar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [showMenu, setShowMenu] = useState(false);
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userName, setUserName] = useState("");
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
//   const dropdownRef = useRef(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchLoading, setSearchLoading] = useState(false);
//   const [cartCount, setCartCount] = useState(0);
//   const [wishcount, setWishCount] = useState(0);
//   const [showNotifications, setShowNotifications] = useState(false);
//   const [menuItems, setMenuItems] = useState([]);
//   const [sellerMap, setSellerMap] = useState({});

//   const notificationRef = useRef(null);


  

//   // 🆕 Fetch seller list and create ID-to-name mapping
//   useEffect(() => {
//     const fetchSellers = async () => {
//       try {
//         const res = await axios.get(
//           "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_seller_registration"
//         );

//         if (res.data.status === "true" && Array.isArray(res.data.data)) {
//           const mapping = {};
//           res.data.data.forEach((seller) => {
//             mapping[seller.seller_id] = seller.business_name;
//           });
//           setSellerMap(mapping);
//           console.log("Seller mapping created:", mapping);
//         }
//       } catch (error) {
//         console.error("Seller fetch error:", error);
//       }
//     };

//     fetchSellers();
//   }, []);

//   // Check login status
//   const checkLoginStatus = () => {
//     const user = localStorage.getItem("user");
//     console.log("Checking login status, user data:", user); // Debug log
    
//     if (user) {
//       try {
//         const userData = JSON.parse(user);
//         console.log("Parsed user data:", userData); // Debug log
//         setIsLoggedIn(true);
//         // Try multiple possible fields for user name
//         setUserName(userData.name || userData.username || userData.email || userData.mobile || "User");
//       } catch (error) {
//         console.error("Error parsing user data:", error);
//         localStorage.removeItem("user");
//         setIsLoggedIn(false);
//       }
//     } else {
//       setIsLoggedIn(false);
//     }
//   };

//   // Check on mount and when location changes
//   useEffect(() => {
//     checkLoginStatus();
//   }, [location]);

//   // Listen for custom login event
//   useEffect(() => {
//     const handleLoginEvent = () => {
//       console.log("Login event received"); // Debug log
//       checkLoginStatus();
//     };

//     window.addEventListener("userLoggedIn", handleLoginEvent);
//     return () => window.removeEventListener("userLoggedIn", handleLoginEvent);
//   }, []);

//   const toggleDropdown = (index) => {
//     setOpenDropdownIndex(openDropdownIndex === index ? null : index);
//   };

//   const handleAccordionToggle = (index) => {
//     if (window.innerWidth <= 768) {
//       setActiveDropdown((prevIndex) => (prevIndex === index ? null : index));
//     }
//   };

//  const handleLogout = () => {
//   console.log("Logging out...");

//   // ✅ Clear ALL auth-related data
//   localStorage.removeItem("user");
//   localStorage.removeItem("user_id"); // 🔥 THIS WAS MISSING
//   localStorage.removeItem("cart");
//   localStorage.removeItem("wishlist");
//   localStorage.removeItem("address");
//   localStorage.removeItem("orders");

//   sessionStorage.clear();

//   // 🔥 Notify whole app
//   window.dispatchEvent(new Event("userLoggedOut"));

//   // Reset UI state
//   setIsLoggedIn(false);
//   setUserName("");
//   setShowDropdown(false);

//   toast.success("Logged out successfully!");
//   navigate("/");
// };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleSearch = async () => {
//     if (!searchQuery.trim()) return;

//     try {
//       setSearchLoading(true);

//       const res = await axios.get(
//         "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_create_product"
//       );

//       if (res.data.status === true && res.data.data) {
//         const query = searchQuery.toLowerCase();

//         // ✅ ENHANCED FILTER: Include seller business name in search
//         const matchedProducts = res.data.data.filter((item) => {
//           const sellerName = sellerMap[item.seller_id] || "";
          
//           return (
//             `${item.product_name} ${item.company_name} ${item.model_name} ${sellerName}`
//               .toLowerCase()
//               .includes(query)
//           );
//         });

//         // ✅ TRANSFORM (VERY IMPORTANT)
//         const transformedProducts = matchedProducts.map((product) => ({
//           id: product.product_id,
//           brand: product.company_name || product.assign_vendor,
//           name: product.product_name,
//           price: parseFloat(product.current_price),
//           oldPrice: parseFloat(product.old_price),
//           discount: Math.round(
//             ((parseFloat(product.old_price) - parseFloat(product.current_price)) /
//               parseFloat(product.old_price)) *
//               100
//           ),
//           category: product.subcategory_id,
//           category_id: Number(product.category_id),
//           subcategory_id: Number(product.subcategory_id),
//           color: product.available_colors,
//           images:
//             product.multi_image?.length > 0
//               ? product.multi_image.map(
//                   (img) =>
//                     `https://cyberathon.com/multivendor/${img}`
//                 )
//               : ["img/placeholder.jpg"],
//           rating: parseFloat(product.rating) || 0,
//           viewers: `${parseFloat(product.rating || 0).toFixed(1)}K`,
//           stock: product.status || "In Stock",
//           description: product.description,
//           productDetails: product.product_details,
//           sellerName: sellerMap[product.seller_id] || "Unknown Seller",
//         }));

//         console.log(`Found ${transformedProducts.length} products matching "${searchQuery}"`);

//         // ✅ NAVIGATE TO PRODUCTS PAGE
//         navigate("/products", {
//           state: {
//             query: searchQuery,
//             results: transformedProducts,
//           },
//         });
//       }
//     } catch (error) {
//       console.error("Search Error:", error);
//       toast.error("Search failed");
//     } finally {
//       setSearchLoading(false);
//     }
//   };

// useEffect(() => {
//   fetchwishCount();
// }, [location, isLoggedIn]);

// const fetchwishCount = async () => {
//   const user_id = localStorage.getItem("user_id");

//   // 🧑‍🦱 GUEST USER
//   if (!user_id) {
//     const guestwish =
//       JSON.parse(localStorage.getItem("guest_wishlist")) ||
//       JSON.parse(localStorage.getItem("wishlist")) ||
//       [];
//     setWishCount(guestwish.length);
//     return;
//   }

//   // 👤 LOGGED-IN USER
//   try {
//     const formData = new FormData();
//     formData.append("user_id", user_id);

//     const res = await axios.post(
//       "https://cyberathon.com/streekatha/API/index.php/Master_controller/wish_list",
//       formData,
//       { headers: { "Content-Type": "multipart/form-data" } }
//     );
//     console.log("Wishlist count response:", res.data); 

//     if (res.data.status === true || res.data.status === "true") {
//       // 🔥 FIX: Set the LENGTH of the wishlist array, not the array itself
//       const wishlistArray = res.data.wishlist || [];
//       setWishCount(Array.isArray(wishlistArray) ? wishlistArray.length : 0);
//     } else {
//       setWishCount(0);
//     }
//   } catch (error) {
//     console.error("Wishlist count error:", error);
//     setWishCount(0);
//   }
// };

// useEffect(() => {
//   const handlewishUpdate = () => fetchwishCount();

//   window.addEventListener("wishUpdated", handlewishUpdate);
//   window.addEventListener("userLoggedOut", handlewishUpdate);

//   return () => {
//     window.removeEventListener("wishUpdated", handlewishUpdate);
//     window.removeEventListener("userLoggedOut", handlewishUpdate);
//   };
// }, []);

// useEffect(() => {
//   fetchCartCount();
// }, [location, isLoggedIn]);

// useEffect(() => {
//   const handleClickOutside = (e) => {
//     if (
//       notificationRef.current &&
//       !notificationRef.current.contains(e.target)
//     ) {
//       setShowNotifications(false);
//     }
//   };

//   document.addEventListener("mousedown", handleClickOutside);
//   return () =>
//     document.removeEventListener("mousedown", handleClickOutside);
// }, []);

// const fetchCartCount = async () => {
//   const user_id = localStorage.getItem("user_id");

//   // 🧑‍🦱 GUEST USER
//   if (!user_id) {
//     const guestCart =
//       JSON.parse(localStorage.getItem("guest_cart")) ||
//       JSON.parse(localStorage.getItem("cart")) ||
//       [];
//     setCartCount(guestCart.length);
//     return;
//   }

//   // 👤 LOGGED-IN USER
//   try {
//     const res = await axios.post(
//       "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_cart",
//       { user_id }
//     );

//     if (res.data.status === true && Array.isArray(res.data.data)) {
//       setCartCount(res.data.data.length);
//     } else {
//       setCartCount(0);
//     }
//   } catch (error) {
//     console.error("Cart count error:", error);
//     setCartCount(0);
//   }
// };

// useEffect(() => {
//   const handleCartUpdate = () => fetchCartCount();

//   window.addEventListener("cartUpdated", handleCartUpdate);
//   window.addEventListener("userLoggedOut", handleCartUpdate);

//   return () => {
//     window.removeEventListener("cartUpdated", handleCartUpdate);
//     window.removeEventListener("userLoggedOut", handleCartUpdate);
//   };
// }, []);

// // const CATEGORY_MAP = {
// //   1: "Electronics",
// //   2: "Fashion",
// //   3: "Home",
// //   4: "Beauty",
// // };

// const CATEGORY_MAP = {
//   1: "Home",
//   2: "Men",
//   3: "Women",
//   4: "Kids",
//   5:"Beauty"
// };


//   const STATIC_NAV_LINKS = [
//   { label: "Story", path: "/story" },
//   { label: "About", path: "/about" },
// ];


//   useEffect(() => {
//   fetchSubCategories();
// }, []);

// const fetchSubCategories = async () => {
//   try {
//     const res = await axios.get(
//       "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_main_subcategory"
//     );

//     if (res.data.status === "true") {
//       const rows = res.data.row;

//       // Group by category_id
//       const grouped = rows.reduce((acc, item) => {
//         const catName = CATEGORY_MAP[item.category_id] || "Other";

//         if (!acc[catName]) {
//           acc[catName] = [];
//         }

//         acc[catName].push({
//           id: item.subcategory_id,
//           name: item.subcategory_name,
//           image: item.image,
//           path: `/products?subcategory=${item.subcategory_id}`,
//         });

//         return acc;
//       }, {});

//       // Convert to menu format
//       const finalMenu = Object.keys(grouped).map((key) => ({
//         label: key,
//         items: grouped[key],
//       }));

//       setMenuItems(finalMenu);
//     }
//   } catch (error) {
//     console.error("Subcategory fetch error:", error);
//   }
// };

//   return (
//     <div>
//       <div className="header sticky">
//         <div className="nav-logo">
//           <Link to="/">
//             <img src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png" alt="logo" />
//           </Link>
//         </div>

//         {/* MOBILE MENU ICON */}
//         <div
//           className="d-block d-lg-none"
//           onClick={() => setIsMobileMenuOpen((prev) => !prev)}
//         >
//           <div className="mobile-menu-icon">
//             <i className={`fas ${isMobileMenuOpen ? "fa-times" : "fa-bars"}`}></i>
//           </div>
//         </div>

// {/* MOBILE MENU ITEMS */}
// {isMobileMenuOpen && (
//   <div className="mobile-menu m-1">
//     <ul className="mobile-menu-list">
//       {menuItems.map((menu, index) => (
//         <li key={index} className="mobile-menu-item">
//           {/* Menu Label */}
//           <div
//             className="menu-label d-flex justify-content-between align-items-center"
//             onClick={(e) => {
//               e.stopPropagation(); // 🧩 Prevent conflict with parent click
//               setOpenDropdownIndex((prev) => (prev === index ? null : index));
//             }}
//             style={{
//               cursor: "pointer",
//               fontWeight: "600",
//               padding: "10px 0",
//               borderBottom: "1px solid #e0e0e0",
//             }}
//           >
//             {menu.label}
//             <span className="mobile-arrow">
//               {openDropdownIndex === index ? "▲" : "▼"}
//             </span>
//           </div>

//           {/* Dropdown Items */}
//           {openDropdownIndex === index && (
//             <ul
//               className="submenu"
//               style={{
//                 listStyle: "none",
//                 paddingLeft: "15px",
//                 marginTop: "8px",
//                 marginBottom: "10px",
//                 backgroundColor: "#f9f9f9",
//                 borderRadius: "5px",
//                 overflow: "hidden",
//               }}
//             >
//               {menu.items.map((item, subIndex) => (
//                 <li
//                   key={subIndex}
//                   style={{
//                     padding: "8px 0",
//                     borderBottom: "1px solid #ddd",
//                   }}
//                 >
//                   <Link
//                     to={item.path}
//                     onClick={() => {
//                       setIsMobileMenuOpen(false);
//                       setOpenDropdownIndex(null);
//                     }}
//                     style={{
//                       color: "#333",
//                       textDecoration: "none",
//                       display: "block",
//                     }}
//                   >
//                     {item.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </li>
//       ))}
//     </ul>
//   </div>
// )}

//         <div className={`categories ${showMenu ? "show" : ""}`}>
//   <ul className="categories-ul">

//     {menuItems.map((menu, index) => (
//       <li
//         key={index}
//         className={`dropdown-content${index + 1} ${
//           activeDropdown === index ? "active" : ""
//         }`}
//       >
//         <a
//           href="#"
//           onClick={(e) => {
//             if (window.innerWidth <= 768) {
//               e.preventDefault();
//               handleAccordionToggle(index);
//             }
//           }}
//         >
//           {menu.label}

//           <span className="mobile-arrow">
//             {activeDropdown === index ? "▲" : "▼"}
//           </span>
//         </a>

//         {menu.items.length > 0 && (
//           <div className={`dropdown-menu dropdown-menu${index + 1}`}>
//             <div className="mega-menu-grid">

//               {Array.from(
//                 { length: Math.ceil(menu.items.length / 8) },
//                 (_, colIndex) => (
//                   <div className="mega-column" key={colIndex}>
//                     <h6>{menu.label}</h6>

//                     <ul>
//                       {menu.items
//                         .slice(colIndex * 8, colIndex * 8 + 8)
//                         .map((item, i) => (
//                           <li key={i}>
//                             <Link to={item.path}>
//                               {item.name}
//                             </Link>
//                           </li>
//                         ))}
//                     </ul>
//                   </div>
//                 )
//               )}

//             </div>
//           </div>
//         )}
//       </li>
//     ))}

//   </ul>
// </div>

//         <div
//           className="d-flex justify-content-center align-items-center p-3 nav-search"
//         >
//           <div
//             className="d-flex align-items-center rounded overflow-hidden"
//             style={{ width: "100%", backgroundColor: "#fff", border:"1px solid" }}
//           >
//             <div className="dropdown border-end" style={{ backgroundColor: "#f3f3f3" }}>
//               {/* <button
//                 className="btn dropdown-toggle text-muted"
//                 type="button"
//                 data-bs-toggle="dropdown"
//                 aria-expanded="false"
//                 style={{
//                   height: "38px",
//                   borderRadius: "0",
//                   backgroundColor: "#f3f3f3",
//                   border: "none",
//                   fontSize: "14px",
//                   padding: "0 10px",
//                 }}
//               >
//                 All
//               </button> */}
//               <ul className="dropdown-menu">
//                 <li>
//                   <a className="dropdown-item" href="#">
//                     All Categories
//                   </a>
//                 </li>
//                 <li>
//                   <a className="dropdown-item" href="#">
//                     Electronics
//                   </a>
//                 </li>
//                 <li>
//                   <a className="dropdown-item" href="#">
//                     Fashion
//                   </a>
//                 </li>
//               </ul>
//             </div>

//             <input
//               type="text"
//               className="form-control border-0"
//               placeholder="Search products or sellers..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && handleSearch()}
//               style={{
//                 boxShadow: "none",
//                 height: "38px",
//                 fontSize: "14px",
//               }}
//             />

//             <button
//               className="btn d-flex align-items-center justify-content-center"
//               onClick={handleSearch}
//               disabled={searchLoading}
//               style={{
//                 backgroundColor: "black",
//                 borderRadius: "0",
//                 width: "45px",
//                 height: "38px",
//               }}
//             >
//               <i className="bi bi-search fs-5 text-white"></i>
//             </button>
//           </div>
//         </div>

//         <div className="nav-last">
//           <div
//             className="profile-last-section"
//             onMouseEnter={() => setShowDropdown(true)}
//           >
//             <div
//               className="profile-icon"
//               onClick={() => setShowDropdown(!showDropdown)}
//             >
//               <img
//                 id="svg"
//                 src="https://www.svgrepo.com/show/198180/user-profile.svg"
//                 alt="profile"
//               />
//               <div>Profile</div>
//             </div>

//             {showDropdown && (
//               <div className="profile-dropdown" ref={dropdownRef}>
//                 {!isLoggedIn ? (
//                   <>
//                     <div className="welcome">
//                       <p>Welcome</p>
//                       <span>To access account and manage orders</span>
//                       <Link to="/login" onClick={() => setShowDropdown(false)}>
//                         <button>LOGIN / SIGNUP</button>
//                       </Link>
//                     </div>
//                     <hr />
//                   </>
//                 ) : (
//                   <>
//                     <div className="welcome">
//                       <p>Hello, {userName}!</p>
//                       <button 
//                         onClick={handleLogout} 
//                         style={{ 
//                           marginTop: "10px",
//                           cursor: "pointer",
//                         }}
//                       >
//                         LOGOUT
//                       </button>
//                     </div>
//                     <hr className="mt-0"/>
//                   </>
//                 )}
//                 <ul>
//                   <Link to="/Profilepage" onClick={() => setShowDropdown(false)}>
//                     <li>Profile</li>
//                   </Link>
//                   <Link to="/order" onClick={() => setShowDropdown(false)}>
//                     <li>Orders</li>
//                   </Link>
//                   <Link to="/Referfrnd" onClick={() => setShowDropdown(false)}>
//                     <li>Refer a friend</li>
//                   </Link>
//                   <li>Gift Cards</li>
//                   {/* <Link to="/ContactUs" onClick={() => setShowDropdown(false)}>
//                     <li>Contact Us</li>
//                   </Link> */}
//                   <Link to="/Coupan" onClick={() => setShowDropdown(false)}>
//                     <li>Coupons</li>
//                   </Link>
//                 </ul>
//               </div>
//             )}
//           </div>

//           <div className="profile-last-section position-relative">
//             <Link to="/wishlist" className="text-decoration-none text-dark position-relative">
//               <img
//                 id="svg"
//                 src="https://www.svgrepo.com/show/14970/heart.svg"
//                 alt=""
//               />
//               {wishcount > 0 && (
//                 <span
//                   style={{
//                     position: "absolute",
//                     top: "-5px",
//                     right: "-2px",
//                     background: "red",
//                     color: "white",
//                     borderRadius: "50%",
//                     padding: "2px 6px",
//                     fontSize: "11px",
//                     fontWeight: "bold",
//                     minWidth: "18px",
//                     textAlign: "center",
//                   }}
//                 >
//                   {wishcount}
//                 </span>
//               )}
//               <div>Wishlist</div>
//             </Link>
//           </div>

//           <div className="profile-last-section position-relative">
//             <Link to="/bag" className="text-decoration-none text-dark position-relative">
//               <FaShoppingBag size={19} />

//               {cartCount > 0 && (
//                 <span
//                   style={{
//                     position: "absolute",
//                     top: "-6px",
//                     right: "-8px",
//                     background: "red",
//                     color: "white",
//                     borderRadius: "50%",
//                     padding: "2px 6px",
//                     fontSize: "11px",
//                     fontWeight: "bold",
//                     minWidth: "18px",
//                     textAlign: "center",
//                   }}
//                 >
//                   {cartCount}
//                 </span>
//               )}

//               <div>Bag</div>
//             </Link>
//           </div>

//           <div
//             className="profile-last-section position-relative"
//             ref={notificationRef}
//           >
//             <div
//               className="text-dark text-center"
//               style={{ cursor: "pointer" }}
//               onClick={() => setShowNotifications((prev) => !prev)}
//             >
//               <i className="fa-regular fa-bell" style={{ fontSize: "18px" }}></i>
//               <div>Notifications</div>
//             </div>

//             {showNotifications && <NotificationDropdown />}
//           </div>
//         </div>
//       </div>
//       <div></div>
//     </div>
//   );
// };

// export default Navbar;    













// 02-11-2026
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import NotificationDropdown from "./Notification";
import "./Navbar.css";

/* ------------------------------------------------------------------
   LOGO
   Abhi placeholder link hai. Baad mein image public/images/logo.png
   mein rakho aur ye line aisi kar do:
   const LOGO_SRC = "/images/logo.png";
------------------------------------------------------------------- */
const LOGO_SRC = "/img/logoN1.jpeg";
// const BRAND_NAME = "STREEKATHA"; 
const BRAND_PARTS = ["STREE", "KATHA"];
const BRAND_NAME = BRAND_PARTS.join("");


const API_BASE =
  "https://cyberathon.com/streekatha/API/index.php/Master_controller";


const Z_API_BASE =
  "https://cyberathon.com/streekatha/API/index.php/Master_controller";

const PRODUCTS_PATH = "/products";

/* ---------------- Original category map (same as before) ---------------- */
// const CATEGORY_MAP = {
//   1: "Home",
//   2: "Men",
//   3: "Women",
//   4: "Kids",
//   5: "Beauty",
// };

/* ------------------------------------------------------------------
   GEHEN STATIC LINKS (screenshot wale) - abhi COMMENT mein hain.
   Jab senior bole:
   1) neeche ka poora block uncomment karo
   2) component ke andar jahan "const navLinks = DYNAMIC_LINKS;" likha hai
      usse comment karke "const navLinks = GEHEN_LINKS;" uncomment karo
------------------------------------------------------------------- */
const GEHEN_LINKS = [
  { label: "Home", path: "/" },
  // { label: "All Sarees", path: PRODUCTS_PATH },
  { label: "All Sarees", path: "/all-sarees" },
  // { label: "New Arrivals", path: PRODUCTS_PATH },
  { label: "New Arrivals", path: "/new-arrivals" },
  {
    label: "Premium Collection",
    // path: PRODUCTS_PATH,
    path: "/premium-collection",
    children: [
      // { label: "Banarasi Saree", path: PRODUCTS_PATH },
      { label: "Banarasi Saree", path: "/banarasi-saree" },
      { label: "Maheshwari Silk", path: PRODUCTS_PATH },
      { label: "Mulmul", path: PRODUCTS_PATH },
      { label: "Kota Cotton", path: PRODUCTS_PATH },
    ],
  },
  // { label: "Shop", path: PRODUCTS_PATH },
  { label: "Shop", path: "/shop" },
  // { label: "Tissue", path: PRODUCTS_PATH },
  { label: "Tissue", path: "/tissue" },
  // { label: "Linen", path: PRODUCTS_PATH },
  { label: "Linen", path: "/linen" },
  // { label: "Mulmul", path: PRODUCTS_PATH },
  { label: "Mulmul", path: "/mul-mul" },
  // { label: "Dual Shade", path: PRODUCTS_PATH },
  { label: "Dual Shade", path: "/dual-shade" },
  // { label: "Festive Select", path: PRODUCTS_PATH },
  { label: "Festive Select", path: "/festive-select" },
];


const BrandText = () => (
  <span aria-label={BRAND_NAME}>
    {BRAND_PARTS.map((part, i) => (
      <span key={i} className="navparatha-brand-word">
        <span className="navparatha-brand-cap">{part.charAt(0)}</span>
        {part.slice(1)}
      </span>
    ))}
  </span>
);

/* ---------------------------- ICONS ---------------------------- */
const svgProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

const UserIcon = () => (
  <svg {...svgProps} width="22" height="22">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" />
  </svg>
);

const SearchIcon = ({ size = 22 }) => (
  <svg {...svgProps} width={size} height={size}>
    <circle cx="11" cy="11" r="7" />
    <path d="M20.5 20.5 16 16" />
  </svg>
);

const HeartIcon = () => (
  <svg {...svgProps} width="22" height="22">
    <path d="M12 20.5s-8-4.9-8-11A4.5 4.5 0 0 1 12 6.8 4.5 4.5 0 0 1 20 9.5c0 6.1-8 11-8 11z" />
  </svg>
);

const CartIcon = () => (
  <svg {...svgProps} width="24" height="24">
    <path d="M2 3h3l2.4 12.2a1 1 0 0 0 1 .8h9.4a1 1 0 0 0 1-.8L21 7H6" />
    <circle cx="9.5" cy="20" r="1" />
    <circle cx="17.5" cy="20" r="1" />
  </svg>
);

const BellIcon = () => (
  <svg {...svgProps} width="22" height="22">
    <path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15L6 16z" />
    <path d="M10 21a2 2 0 0 0 4 0" />
  </svg>
);

const CloseIcon = ({ size = 22 }) => (
  <svg {...svgProps} width={size} height={size}>
    <path d="M5 5l14 14M19 5L5 19" />
  </svg>
);

const MenuIcon = () => (
  <svg {...svgProps} width="24" height="24">
    <path d="M3 6h18M3 12h18M3 18h18" />
  </svg>
);

/* --------------------------- COMPONENT -------------------------- */
const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [showDropdown, setShowDropdown] = useState(false); // profile dropdown
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [wishcount, setWishCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  // const [menuItems, setMenuItems] = useState([]);
  const [zMenu, setZMenu] = useState([]);
  const [sellerMap, setSellerMap] = useState({});

  const rootRef = useRef(null);
  const profileRef = useRef(null);
  const notificationRef = useRef(null);
  const searchInputRef = useRef(null);

  /* ---------- Fetch seller list and create ID-to-name mapping ---------- */
  useEffect(() => {
    const fetchSellers = async () => {
      try {
        const res = await axios.get(`${API_BASE}/list_seller_registration`);

        if (res.data.status === "true" && Array.isArray(res.data.data)) {
          const mapping = {};
          res.data.data.forEach((seller) => {
            mapping[seller.seller_id] = seller.business_name;
          });
          setSellerMap(mapping);
          console.log("Seller mapping created:", mapping);
        }
      } catch (error) {
        console.error("Seller fetch error:", error);
      }
    };

    fetchSellers();
  }, []);

  /* ---------------------- Check login status ---------------------- */
  const checkLoginStatus = () => {
    const user = localStorage.getItem("user");
    console.log("Checking login status, user data:", user);

    if (user) {
      try {
        const userData = JSON.parse(user);
        console.log("Parsed user data:", userData);
        setIsLoggedIn(true);
        setUserName(
          userData.name ||
            userData.username ||
            userData.email ||
            userData.mobile ||
            "User"
        );
      } catch (error) {
        console.error("Error parsing user data:", error);
        localStorage.removeItem("user");
        setIsLoggedIn(false);
      }
    } else {
      setIsLoggedIn(false);
    }
  };

  // Check on mount and when location changes
  useEffect(() => {
    checkLoginStatus();
  }, [location]);

  // Listen for custom login event
  useEffect(() => {
    const handleLoginEvent = () => {
      console.log("Login event received");
      checkLoginStatus();
    };

    window.addEventListener("userLoggedIn", handleLoginEvent);
    return () => window.removeEventListener("userLoggedIn", handleLoginEvent);
  }, []);

  /* ---------------------------- Logout ---------------------------- */
  const handleLogout = () => {
    console.log("Logging out...");

    // Clear ALL auth-related data
    localStorage.removeItem("user");
    localStorage.removeItem("user_id");
    localStorage.removeItem("cart");
    localStorage.removeItem("wishlist");
    localStorage.removeItem("address");
    localStorage.removeItem("orders");

    sessionStorage.clear();

    // Notify whole app
    window.dispatchEvent(new Event("userLoggedOut"));

    // Reset UI state
    setIsLoggedIn(false);
    setUserName("");
    setShowDropdown(false);

    toast.success("Logged out successfully!");
    navigate("/");
  };

  /* ---------------- Click outside: profile dropdown ---------------- */
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* -------------- Click outside: notifications dropdown -------------- */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(e.target)
      ) {
        setShowNotifications(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* --------- Click outside / Esc: search panel (naya, UI ke liye) --------- */
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setSearchOpen(false);
    const onClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setSearchOpen(false);
      }
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClick);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClick);
    };
  }, []);

  // Search khulte hi input par focus
  useEffect(() => {
    if (searchOpen && searchInputRef.current) searchInputRef.current.focus();
  }, [searchOpen]);

  // Route change par mobile menu band
  useEffect(() => {
    setIsMobileMenuOpen(false);
    setOpenDropdownIndex(null);
  }, [location.pathname, location.search]);

  /* ----------------------------- Search ----------------------------- */
  const handleSearch = async () => {
    if (!searchQuery.trim()) return;

    try {
      setSearchLoading(true);

      const res = await axios.get(`${API_BASE}/list_create_product`);

      if (res.data.status === true && res.data.data) {
        const query = searchQuery.toLowerCase();

        // ENHANCED FILTER: Include seller business name in search
        const matchedProducts = res.data.data.filter((item) => {
          const sellerName = sellerMap[item.seller_id] || "";

          return `${item.product_name} ${item.company_name} ${item.model_name} ${sellerName}`
            .toLowerCase()
            .includes(query);
        });

        // TRANSFORM (VERY IMPORTANT)
        const transformedProducts = matchedProducts.map((product) => ({
          id: product.product_id,
          brand: product.company_name || product.assign_vendor,
          name: product.product_name,
          price: parseFloat(product.current_price),
          oldPrice: parseFloat(product.old_price),
          discount: Math.round(
            ((parseFloat(product.old_price) -
              parseFloat(product.current_price)) /
              parseFloat(product.old_price)) *
              100
          ),
          category: product.subcategory_id,
          category_id: Number(product.category_id),
          subcategory_id: Number(product.subcategory_id),
          color: product.available_colors,
          images:
            product.multi_image?.length > 0
              ? product.multi_image.map(
                  (img) => `https://cyberathon.com/multivendor/${img}`
                )
              : ["img/placeholder.jpg"],
          rating: parseFloat(product.rating) || 0,
          viewers: `${parseFloat(product.rating || 0).toFixed(1)}K`,
          stock: product.status || "In Stock",
          description: product.description,
          productDetails: product.product_details,
          sellerName: sellerMap[product.seller_id] || "Unknown Seller",
        }));

        console.log(
          `Found ${transformedProducts.length} products matching "${searchQuery}"`
        );

        // NAVIGATE TO PRODUCTS PAGE
        navigate("/products", {
          state: {
            query: searchQuery,
            results: transformedProducts,
          },
        });

        setSearchOpen(false); // result page khulte hi search panel band
      }
    } catch (error) {
      console.error("Search Error:", error);
      toast.error("Search failed");
    } finally {
      setSearchLoading(false);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    handleSearch();
  };

  /* ------------------------- Wishlist count ------------------------- */
  const fetchwishCount = async () => {
    const user_id = localStorage.getItem("user_id");

    // GUEST USER
    if (!user_id) {
      const guestwish =
        JSON.parse(localStorage.getItem("guest_wishlist")) ||
        JSON.parse(localStorage.getItem("wishlist")) ||
        [];
      setWishCount(guestwish.length);
      return;
    }

    // LOGGED-IN USER
    try {
      const formData = new FormData();
      formData.append("user_id", user_id);

      const res = await axios.post(`${API_BASE}/wish_list`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("Wishlist count response:", res.data);

      if (res.data.status === true || res.data.status === "true") {
        // Set the LENGTH of the wishlist array, not the array itself
        const wishlistArray = res.data.wishlist || [];
        setWishCount(Array.isArray(wishlistArray) ? wishlistArray.length : 0);
      } else {
        setWishCount(0);
      }
    } catch (error) {
      console.error("Wishlist count error:", error);
      setWishCount(0);
    }
  };

  useEffect(() => {
    fetchwishCount();
  }, [location, isLoggedIn]);

  useEffect(() => {
    const handlewishUpdate = () => fetchwishCount();

    window.addEventListener("wishUpdated", handlewishUpdate);
    window.addEventListener("userLoggedOut", handlewishUpdate);

    return () => {
      window.removeEventListener("wishUpdated", handlewishUpdate);
      window.removeEventListener("userLoggedOut", handlewishUpdate);
    };
  }, []);

  /* --------------------------- Cart count --------------------------- */
  const fetchCartCount = async () => {
    const user_id = localStorage.getItem("user_id");

    // GUEST USER
    if (!user_id) {
      const guestCart =
        JSON.parse(localStorage.getItem("guest_cart")) ||
        JSON.parse(localStorage.getItem("cart")) ||
        [];
      setCartCount(guestCart.length);
      return;
    }

    // LOGGED-IN USER
    try {
      const res = await axios.post(`${API_BASE}/list_cart`, { user_id });

      if (res.data.status === true && Array.isArray(res.data.data)) {
        setCartCount(res.data.data.length);
      } else {
        setCartCount(0);
      }
    } catch (error) {
      console.error("Cart count error:", error);
      setCartCount(0);
    }
  };

  useEffect(() => {
    fetchCartCount();
  }, [location, isLoggedIn]);

  useEffect(() => {
    const handleCartUpdate = () => fetchCartCount();

    window.addEventListener("cartUpdated", handleCartUpdate);
    window.addEventListener("userLoggedOut", handleCartUpdate);

    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdate);
      window.removeEventListener("userLoggedOut", handleCartUpdate);
    };
  }, []);

  /* ------------------------- Sub categories ------------------------- */
  // const fetchSubCategories = async () => {
  //   try {
  //     const res = await axios.get(`${API_BASE}/list_main_subcategory`);

  //     if (res.data.status === "true") {
  //       const rows = res.data.row;

  //       // Group by category_id
  //       const grouped = rows.reduce((acc, item) => {
  //         const catName = GEHEN_LINKS[item.category_id] || "Other";

  //         if (!acc[catName]) {
  //           acc[catName] = [];
  //         }

  //         acc[catName].push({
  //           id: item.subcategory_id,
  //           name: item.subcategory_name,
  //           image: item.image,
  //           path: `/products?subcategory=${item.subcategory_id}`,
  //         });

  //         return acc;
  //       }, {});

  //       // Convert to menu format
  //       const finalMenu = Object.keys(grouped).map((key) => ({
  //         label: key,
  //         items: grouped[key],
  //       }));

  //       setMenuItems(finalMenu);
  //     }
  //   } catch (error) {
  //     console.error("Subcategory fetch error:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchSubCategories();
  // }, []);


  /* ------------------------- Navbar menu (API) ------------------------- */
useEffect(() => {
  const fetchZMenu = async () => {
    try {
      const res = await axios.get(`${Z_API_BASE}/list_z_menu`);
      if (res.data.status === "true" && Array.isArray(res.data.data)) {
        setZMenu(res.data.data);
      }
    } catch (error) {
      console.error("Menu fetch error:", error);
    }
  };

  fetchZMenu();
}, []);

  /* ------------------------------------------------------------------
     NAV LINKS
     Home (static) + API se aane wale categories (Home/Men/Women/Kids/Beauty)
  ------------------------------------------------------------------- */
  // const DYNAMIC_LINKS = [
  //   { label: "Home", path: "/" },
  //   ...menuItems.map((menu) => ({
  //     label: menu.label,
  //     path: PRODUCTS_PATH,
  //     children: menu.items.map((item) => ({
  //       label: item.name,
  //       path: item.path,
  //     })),
  //   })),
  // ];

  // // const navLinks = DYNAMIC_LINKS;
  // const navLinks = GEHEN_LINKS; 

  const DYNAMIC_LINKS = [
  { label: "Home", path: "/" },
  ...zMenu.map((cat) => ({
    label: cat.name,
    path: `/${cat.slug}`,
    children: (cat.children || []).map((sub) => ({
      label: sub.name,
      path: `/${cat.slug}?subcategory=${sub.id}`,
    })),
  })),
];

// API se data aaya to wahi dikhega, warna (loading/error) purane static links
const navLinks = zMenu.length > 0 ? DYNAMIC_LINKS : GEHEN_LINKS;

  // Dropdown ko 8-8 items ke columns mein todta hai (original mega-menu jaisa)
  const chunk = (arr, size = 8) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  };

  /* ----------------------------- RENDER ----------------------------- */
  return (
    <div className="navparatha-root" ref={rootRef}>
      <header className="navparatha-header">
        {/* Mobile hamburger */}
        <button
          type="button"
          className="navparatha-burger"
          aria-label="Toggle menu"
          onClick={() => setIsMobileMenuOpen((p) => !p)}
        >
          {isMobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
        </button>

        {/* Logo */}
        <Link to="/" className="navparatha-logo" aria-label="Home">
          <img src={LOGO_SRC} alt="logo" />
        </Link>

        {/* <Link to="/" className="navparatha-brand-mobile">{BRAND_NAME}</Link> */}
        <Link to="/" className="navparatha-brand-mobile"><BrandText /></Link>

        {/* Desktop nav */}
        <nav className="navparatha-nav" aria-label="Main">
          {/* <Link to="/" className="navparatha-brand">{BRAND_NAME}</Link> */}
          <Link to="/" className="navparatha-brand"><BrandText /></Link>
          <ul className="navparatha-list">
            {navLinks.map((item) => (
              <li
                key={item.label}
                className={`navparatha-item ${
                  item.children && item.children.length > 0
                    ? "navparatha-has-dropdown"
                    : ""
                }`}
              >
                <Link to={item.path} className="navparatha-link">
                  {item.label}
                </Link>

                {item.children && item.children.length > 0 && (
                  <div className="navparatha-dropdown">
                    {chunk(item.children).map((col, colIndex) => (
                      <ul className="navparatha-dropdown-col" key={colIndex}>
                        {col.map((child, i) => (
                          <li key={`${child.label}-${i}`}>
                            <Link
                              to={child.path}
                              className="navparatha-dropdown-link"
                            >
                              {child.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    ))}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </nav>

        {/* Right icons */}
        <div className="navparatha-icons">
          {/* Profile */}
          <div
            className="navparatha-icon-wrap"
            ref={profileRef}
            onMouseEnter={() => setShowDropdown(true)}
            onMouseLeave={() => setShowDropdown(false)}
          >
            <button
              type="button"
              className="navparatha-icon-btn"
              aria-label="Profile"
              onClick={() => setShowDropdown((p) => !p)}
            >
              <UserIcon />
            </button>

            {showDropdown && (
              <div className="navparatha-profile-dropdown">
                {!isLoggedIn ? (
                  <div className="navparatha-welcome">
                    <p>Welcome</p>
                    <span>To access account and manage orders</span>
                    <Link to="/login" onClick={() => setShowDropdown(false)}>
                      <button type="button" className="navparatha-welcome-btn">
                        LOGIN / SIGNUP
                      </button>
                    </Link>
                  </div>
                ) : (
                  <div className="navparatha-welcome">
                    <p>Hello, {userName}!</p>
                    <button
                      type="button"
                      className="navparatha-welcome-btn"
                      onClick={handleLogout}
                    >
                      LOGOUT
                    </button>
                  </div>
                )}

                <ul className="navparatha-profile-list">
                  <li>
                    <Link to="/Profilepage" onClick={() => setShowDropdown(false)}>
                      Profile
                    </Link>
                  </li>
                  <li>
                    <Link to="/order" onClick={() => setShowDropdown(false)}>
                      Orders
                    </Link>
                  </li>
                  <li>
                    <Link to="/Referfrnd" onClick={() => setShowDropdown(false)}>
                      Refer a friend
                    </Link>
                  </li>
                  <li>
                    <span className="navparatha-profile-plain">Gift Cards</span>
                  </li>
                  <li>
                    <Link to="/Coupan" onClick={() => setShowDropdown(false)}>
                      Coupons
                    </Link>
                  </li>
                </ul>
              </div>
            )}
          </div>

          {/* Search */}
          <div className="navparatha-icon-wrap">
            <button
              type="button"
              className="navparatha-icon-btn"
              aria-label="Search"
              aria-expanded={searchOpen}
              onClick={() => setSearchOpen((p) => !p)}
            >
              <SearchIcon />
            </button>
          </div>

          {/* Wishlist */}
          {/* <div className="navparatha-icon-wrap">
            <Link to="/wishlist" className="navparatha-icon-btn" aria-label="Wishlist">
              <HeartIcon />
              {wishcount > 0 && (
                <span className="navparatha-badge">{wishcount}</span>
              )}
            </Link>
          </div> */}

          {/* Bag */}
          <div className="navparatha-icon-wrap">
            <Link to="/bag" className="navparatha-icon-btn" aria-label="Bag">
              <CartIcon />
              {cartCount > 0 && (
                <span className="navparatha-badge">{cartCount}</span>
              )}
            </Link>
          </div>

          {/* Notifications */}
          {/* <div className="navparatha-icon-wrap" ref={notificationRef}>
            <button
              type="button"
              className="navparatha-icon-btn"
              aria-label="Notifications"
              onClick={() => setShowNotifications((prev) => !prev)}
            >
              <BellIcon />
            </button>

            {showNotifications && <NotificationDropdown />}
          </div> */}
        </div>
      </header>

      {/* Search panel: header ke neeche, banner ke UPAR overlay hota hai */}
      <div
        className={`navparatha-search-panel ${searchOpen ? "navparatha-open" : ""}`}
      >
        <form className="navparatha-search-form" onSubmit={handleSearchSubmit}>
          <span className="navparatha-search-lead">
            <SearchIcon size={20} />
          </span>
          <input
            ref={searchInputRef}
            type="text"
            className="navparatha-search-input"
            placeholder="Search products or sellers..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            disabled={searchLoading}
            tabIndex={searchOpen ? 0 : -1}
          />
          <button
            type="button"
            className="navparatha-search-close"
            aria-label="Close search"
            onClick={() => setSearchOpen(false)}
            tabIndex={searchOpen ? 0 : -1}
          >
            <CloseIcon />
          </button>
        </form>
      </div>

      {/* Mobile drawer */}
      <div
        className={`navparatha-mobile ${isMobileMenuOpen ? "navparatha-open" : ""}`}
      >
        <ul className="navparatha-mobile-list">
          {navLinks.map((item, index) => (
            <li key={item.label} className="navparatha-mobile-item">
              {item.children && item.children.length > 0 ? (
                <>
                  <button
                    type="button"
                    className="navparatha-mobile-toggle"
                    onClick={() =>
                      setOpenDropdownIndex((prev) => (prev === index ? null : index))
                    }
                  >
                    {item.label}
                    <span>{openDropdownIndex === index ? "−" : "+"}</span>
                  </button>

                  {openDropdownIndex === index && (
                    <ul className="navparatha-mobile-sub">
                      {item.children.map((c, i) => (
                        <li key={`${c.label}-${i}`}>
                          <Link
                            to={c.path}
                            onClick={() => {
                              setIsMobileMenuOpen(false);
                              setOpenDropdownIndex(null);
                            }}
                          >
                            {c.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : (
                <Link
                  to={item.path}
                  className="navparatha-mobile-link"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Navbar;